import api, {isBeaconSupported} from '@js/actions/api';
import Orchestrator from '@js/modules/orchestrator';

function sendBeaconOrPromise(url, params) {
    if (isBeaconSupported()) {
        return new Promise((resolve) => {
            api.sendBeacon(url, params);

            resolve();
        });
    } else {
        return api.post(url, params);
    }
}


export const updateTrackingConfiguration = (properties) => (
    sendBeaconOrPromise('/api/v1/tracking/configuration', properties)
);

export const trackConversion = (conversionData) => (
    sendBeaconOrPromise('/api/v1/tracking/conversion', conversionData)
);

export const trackEvent = (name, properties = {}) => (
    sendBeaconOrPromise('/api/v1/tracking/event', {
        name,
        properties
    })
);

export const trackLimitReached = (requiredFunctionality, activity = null) => (
    api.post('/api/v1/tracking/limit-reached', {
        functionality: requiredFunctionality,
        activity
    })
);

export const trackTrialAction = (actionType, origin = 'banner') => (
    sendBeaconOrPromise('/api/v1/tracking/trial-action', {
        action_type: actionType,
        origin: origin
    })
);

const INTENT_KEYS = ['save', 'basket', 'signup'];

// The live intent at exposure (Orchestrator, every arm): the covariate of the server's variance reduction.
const _intentSnapshot = () => {
    const score = Orchestrator.intent();
    const intent = {};

    INTENT_KEYS.forEach((key) => {
        const value = score?.[key];
        if (typeof value === 'number' && value >= 0 && value <= 1) {
            intent[key] = value;
        }
    });

    return Object.keys(intent).length ? {intent} : {};
};

// The visitor reached where an A/B experiment decides: the server recomputes their variant and tracks the exposure.
export const trackExperimentExposure = (name, details = {}) => (
    sendBeaconOrPromise('/api/v1/tracking/experiment', {name, ..._intentSnapshot(), ...details})
);

// The visitor reached where a bandit decides (Bandits): the server records their arm and its share.
// The arm the page displayed (window.bandits, drawn at render): the shares may have moved since.
export const trackBanditExposure = (name) => (
    sendBeaconOrPromise('/api/v1/tracking/bandit', {name, arm: window.bandits?.[name] || null, ..._intentSnapshot()})
);

export const trackPaymentAttempt = (paymentTool, paymentMethod = null) => (
    sendBeaconOrPromise('/api/v1/tracking/payment-attempt', {
        paymentTool,
        paymentMethod
    })
);

export const trackPaymentError = (paymentError) => (
    sendBeaconOrPromise('/api/v1/tracking/payment-error', {
        paymentError
    })
);
